import { delay, HttpResponse, http } from "msw";

import { getHandlersDelay } from "@/services/http";

import { fetchAddressesMock } from "./fetch-addresses.mock";
import { FETCH_ADDRESSES_ENDPOINT } from "./fetch-addresses.request";

const fetchAddressesRegex = new RegExp(FETCH_ADDRESSES_ENDPOINT);

export const fetchAddressesHandler = () =>
  http.get(fetchAddressesRegex, async () => {
    await delay(getHandlersDelay());
    return HttpResponse.json(fetchAddressesMock, { status: 200 });
  });

export const fetchAddressesNotFoundHandler = () =>
  http.get(fetchAddressesRegex, async () => {
    await delay(getHandlersDelay());
    return HttpResponse.json(
      {
        addresses: [],
      },
      { status: 200 },
    );
  });
